export const BlockquoteRenderer = (props: any) => {
  return <blockquote className="otro-blockquote">{props.children}</blockquote>
}
